import React from 'react';
import { Box, IconButton, Tooltip, Typography } from '@mui/material';
import MailIcon from '@mui/icons-material/Mail';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import TwitterIcon from '@mui/icons-material/Twitter';
import FacebookIcon from '@mui/icons-material/Facebook';
import LinkIcon from '@mui/icons-material/Link';

import { BaseComponent } from '../Component';
import { theme } from '../../theme/theme';

import { SocialButton } from './SocialButton';

export interface ShareSocialsComponent extends BaseComponent {
  type: 'shareSocials';
  props: ShareSocialsProps;
}

export interface ShareSocialsProps {
  url: string;
  title: string;
  hideEmail?: boolean;
  hideLinkedin?: boolean;
  hideTwitter?: boolean;
  hideFacebook?: boolean;
  hideCopyLink?: boolean;
  shareTitle?: string;
  copyLinkText: string;
}

//read react-share documentation here: https://www.npmjs.com/package/react-share https://www.npmjs.com/package/next-share
export const ShareSocials: React.FC<ShareSocialsProps> = ({
  url,
  title,
  hideEmail,
  hideLinkedin,
  hideTwitter,
  hideFacebook,
  hideCopyLink,
  shareTitle,
  copyLinkText,
}) => {
  const emailSrc = `mailto:?subject=${title}&body=${url}`;
  const linkedInSrc = `https://linkedin.com/shareArticle/off-site?url=${url}&title=${title}`;
  const twitterSrc = `https://twitter.com/intent/tweet?text=${title} ${url}`;
  const facebookSrc = `https://www.facebook.com/sharer/sharer.php?u=${url}&t=${title}`;
  return (
    <>
      {title !== undefined && title.trim() !== '' && (
        <Typography
          variant="h5"
          style={{
            fontWeight: 'bold',
            marginBottom: '1rem',
          }}
        >
          {shareTitle}
        </Typography>
      )}
      <Box
        sx={{
          display: 'flex',
          gap: '10px',
        }}
      >
        {!hideEmail && (
          <SocialButton
            src={emailSrc}
            name="Email"
            color="#aaa"
            icon={
              <MailIcon
                sx={{
                  width: '2rem',
                  height: 'auto',
                }}
              />
            }
          />
        )}
        {!hideLinkedin && (
          <SocialButton
            src={linkedInSrc}
            name="LinkedIn"
            color="#0e76a8"
            icon={
              <LinkedInIcon
                sx={{
                  width: '2rem',
                  height: 'auto',
                }}
              />
            }
          />
        )}
        {!hideTwitter && (
          <SocialButton
            src={twitterSrc}
            name="Twitter"
            color="#00acee"
            icon={
              <TwitterIcon
                sx={{
                  width: '2rem',
                  height: 'auto',
                }}
              />
            }
          />
        )}
        {!hideFacebook && (
          <SocialButton
            src={facebookSrc}
            name="Facebook"
            color="#3b5998"
            icon={
              <FacebookIcon
                sx={{
                  width: '2rem',
                  height: 'auto',
                }}
              />
            }
          />
        )}
        {!hideCopyLink && (
          <Box
            style={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              gap: '0.5rem',
            }}
          >
            <Tooltip title={copyLinkText}>
              <IconButton
                sx={{
                  color: 'white',
                  backgroundColor: '#aaa',
                  '&:hover': { backgroundColor: '#aaa' },
                }}
                onClick={() => {
                  navigator.clipboard.writeText(url);
                }}
              >
                <LinkIcon
                  sx={{
                    width: '2rem',
                    height: 'auto',
                  }}
                />
              </IconButton>
            </Tooltip>

            <Typography variant="body2" color={theme.palette.secondary.main}>
              {copyLinkText}
            </Typography>
          </Box>
        )}
      </Box>
    </>
  );
};
